import 'lazysizes'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes } from 'react-router-dom'

import api from '@/api'
import Main from '@/pages/Main/Main'
import { setStoreFormats } from '@/store/slices/app'

import './App.css'

function App() {
  const dispatch = useDispatch()

  // useEffect(() => {
  //   getFormats()
  // }, [])

  const getFormats = () => {
    api.get('/api/event_format/event/zabeg2025_online_999999').then((r) => {  
      dispatch(setStoreFormats(r.data.values))
    })
  }

  return (
    <Routes>
      <Route
        path="/"
        element={<Main />}
      />
    </Routes>
  )
}

export default App
